import { render, staticRenderFns } from "./CartProductSummary.vue?vue&type=template&id=b2df7478&scoped=true&lang=pug"
import script from "./CartProductSummary.vue?vue&type=script&lang=js"
export * from "./CartProductSummary.vue?vue&type=script&lang=js"
import style0 from "./CartProductSummary.vue?vue&type=style&index=0&id=b2df7478&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2df7478",
  null
  
)

export default component.exports